import { useTranslation } from 'react-i18next';
import { Loader } from './loader';

type Properties = {
  isLoading?: boolean;
};

const LoaderWithStateAnnouncement = ({ isLoading }: Properties) => {
  const { t } = useTranslation(['translationReactComponents']);

  if (isLoading === undefined) {
    return null;
  }

  return (
    <>
      <output aria-atomic="true" aria-live="polite" className="rc-visually-hidden">
        {isLoading ? t('Loading events') : t('Events loaded')}
      </output>
      {isLoading ? <Loader /> : null}
    </>
  );
};

export default LoaderWithStateAnnouncement;
